import { get } from "./utils.service";

export const getUserReports = async (userId) => {
  return await get(`/admin/user-reports?userId=${userId}`);
};
